<template>
  <div id="readBlog">
    <div class="message_bar" v-show="messageShow > 0">
      <div v-show="messageShow == 1">
        <p class="loading" style="padding-top:15px;">Loading</p>
        <img src="@/assets/img/loading_new.gif" alt="loading">
      </div>
      <p style="padding: 10px;" v-show="messageShow == 2">{{message}}</p>
    </div>
    <div class="text_box" v-show="messageShow == 0">
      <div class="content">
        <div class="title">
          <img class="headImg" :src="blog.link.headImg" alt="blog head image">
          <h1>{{blog.link.title}}</h1>
          <p class="date">{{blog.link.date}}</p>
          <p class="intro">{{blog.link.intro}}</p>
        </div>
        <span class="text" v-html="blog.html"></span>
        <div class="footer">
          <div @click="navGo('blog')" class="button back">返 回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'readBlog',
  data () {
    return {
      messageShow: 1,
      message: '',
      blog: {
        link: {},
      },
    }
  },
  created: function () {
    this.$store.dispatch('changeIndex', {linkName: 'blog'});
    this.$store.dispatch('isLogin')
      .then(() => {
        return this.$store.dispatch('post', {
          address: '/api/getBlog',
          postData: {
            id: this.$route.params.id,
          }
        });
      })
      .then((data) => {
        if (data.status === 'OK') {
          this.blog = data.blog;
          this.messageShow = 0;
        } else {
          this.navGo('blog');
        }
      })
      .catch((err) => {
        this.messageShow = 2;
        this.message = `[Error] ${err.message}`
      })
  },
  methods: {
    navGo: function ( linkName ) {
      this.$router.push({ name: linkName });
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#readBlog {
  $font-color: #5E5E5E;
  $font-color-light: #9C9C9C;
  $background-color: #F5F5F5;
  $background-color-dark: #EFEFEF;

  .message_bar {
    color: $font-color;
    background-color: $background-color;
    position: relative;
    margin: 0px 50px 30px 50px;
    text-align: center;
  }

  .title {
    text-align: center;
    border: dotted $font-color;
    border-width: 0px 0px 2px 0px;
    margin: 0 0 30px 0;
    padding: 0 0 10px 0;
    .headImg {
      width: 100%;
      margin: 0 0 30px 0;
    }
    .date {
      color: $font-color-light;
      font-size: 0.9em;
      margin: 20px 0 10px 0;
    }
  }
  .text_box {
    margin: 30px 50px;
    padding: 10px;
    background-color: $background-color;
    color: $font-color;
  }
  .content {
    text-align: justify;
    line-height: 1.5em;
    max-width: 786px;
    margin: 10px auto 40px auto;
  }
  .text {
    line-height: 2em;
  }
  .text img {
    max-width: 100%;
  }
  .footer {
    margin: 30px 0 0 0;
    height: 60px;
    border: dotted $font-color;
    border-width: 2px 0 0 0;
    .back {
      float: right;
    }
  }
  @media screen and (max-width: 767px) {
    .message_bar {
      margin: 0px 10px 30px 10px;
    }
    .text_box {
      margin: 10px;
      padding: 10px 20px;
    }
    .content {
      margin: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/readBlog.vue